import { styled } from "@mui/material/styles";
import Slider from "@mui/material/Slider";

/**
 * Slider estilizado compartido por los simuladores de credito
 * (Simulator, SimulatorCuotas, SimulatorRenovar, simulatorv2).
 *
 * Antes cada uno de esos 4 archivos definia su propia copia identica de
 * este componente con `withStyles` de @material-ui/core v4. Ese paquete
 * se elimino del proyecto (ver docs/UPGRADE-CORE-GALILEA.md, tarea 3.2
 * adelantada a la fase 2): su codigo interno importa `findDOMNode` de
 * "react-dom", que React 19 elimino por completo, y eso rompia el build
 * sin importar el orden de fases planeado.
 *
 * Migrado al `styled()` de @mui/material v5, que este proyecto ya usa
 * en otros 33 archivos. Mismo aspecto visual; la unica diferencia real
 * es que las clases de estado de MUI v5 son globales (".Mui-active")
 * en vez de las clases locales que generaba JSS en v4 ("&$active").
 */
const PrettoSlider = styled(Slider)({
  color: "#7E02FC",
  height: 8,
  "& .MuiSlider-thumb": {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    marginTop: -1,
    marginLeft: 0,
    "&:focus, &:hover, &.Mui-active": {
      boxShadow: "inherit",
    },
  },
  "& .MuiSlider-valueLabel": {
    left: "calc(-50% + 4px)",
  },
  "& .MuiSlider-track": {
    height: 8,
    borderRadius: 4,
  },
  "& .MuiSlider-rail": {
    height: 8,
    borderRadius: 4,
  },
});

export default PrettoSlider;
